export default function CohortSummary({ summaryTitle, filterSummaryComponent }: { summaryTitle: string, filterSummaryComponent: Record<string, any> }) {
  return (
    <div className="rounded-lg outline outline-1 outline-pipgrey-light bg-gray-50 p-2">
      <p className="text-start text-xs font-medium text-gray-500 uppercase tracking-wider">{summaryTitle}</p>
      <table>
        <tbody>
          {Object.entries(filterSummaryComponent)
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            .filter(([key, value]) => {
              if (Array.isArray(value)) return value.length > 0;
              return value !== null && value !== undefined && value !== '';
            })
            .map(([key, value]) => (
              <tr key={key}>
                <td className="pr-4 text-start text-xs pt-2 text-gray-500">{key}</td>
                <td className="text-start p-1 ">
                  {Array.isArray(value) ? (
                    <div className="flex flex-wrap gap-2">{value}</div>
                  ) : (
                    value
                  )}
                </td>
              </tr>
            ))}

        </tbody>
      </table>
    </div>
  );
}
